export * as items from '@wix/auto_sdk_promote-growth-tools-publisher_items/schemas';
export * as premiumFeatures from '@wix/auto_sdk_promote-growth-tools-publisher_premium-features/schemas';
export * as accounts from '@wix/auto_sdk_promote-growth-tools-publisher_accounts/schemas';
export * as generatedContent from '@wix/auto_sdk_promote-growth-tools-publisher_generated-content/schemas';
